import React, { Component } from 'react';
import Events from './Events';

import withData from '../utils/withData';

class NoDollar extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}


	/*

		RENDER

	*/

	render() {

		let items = this.props.data.entries.filter((item) => {

			let isFree = (item.free == '1');
			let isEvent = (item.type == 'events')

			if(isFree && isEvent) return true;
		}).map((item) => {

			return item.id;

		})

		return (
			<Events items={items} entry={{title:'Free Events'}} />
		);

	}
}

export default withData(NoDollar);



// WEBPACK FOOTER //
// ./src/js/templates/NoDollar.js